import { render, staticRenderFns } from "./DialogDesasociate.vue?vue&type=template&id=049e58c0"
import script from "./DialogDesasociate.vue?vue&type=script&lang=js"
export * from "./DialogDesasociate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports